export const SAVED_SCREEN_TITLE = "Избранное";